import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PaginationContext } from '../../../../../../../components/pagination/PaginationContext';

type Props = {
  loading: boolean;
};

export const PageOutOfRangeGuard = ({ loading }: Props) => {
  const { count, page, perPage, pageParam } = useContext(PaginationContext);
  const location = useLocation();
  const navigate = useNavigate();
  const isOutOfRange = !loading && perPage !== 0 && count === 0 && page > 1;

  useEffect(() => {
    if (!isOutOfRange) {
      return;
    }
    const params = new URLSearchParams(location.search);
    params.delete(pageParam);
    navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
  }, [isOutOfRange]);

  return null;
};
